import { Paper, Typography, useTheme } from '@mui/material';
import React from 'react';

type PropTypes = {
  correctAnswer: boolean;
  letter: string;
  letterIndex: number;
  timerLimitReached: boolean;
  underline: boolean;
  unrevealedIndex?: number[];
  wordIndex: number;
};

export const Letter = ({
  correctAnswer,
  letter,
  letterIndex,
  timerLimitReached,
  underline,
  unrevealedIndex,
  wordIndex,
}: PropTypes) => {
  const theme = useTheme();

  const isUnrevealedLetter = () =>
    unrevealedIndex &&
    wordIndex === unrevealedIndex[0] &&
    letterIndex === unrevealedIndex[1];

  const wrongAnswerBorder =
    timerLimitReached && !correctAnswer
      ? `1px solid ${theme.palette.error.main}`
      : null;

  const underlineBorderBottom = underline ? '3px solid' : null;

  return (
    <>
      <Paper
        elevation={6}
        className={`${isUnrevealedLetter() ? 'answer-letter-animation' : ''}`}
        variant={timerLimitReached && !correctAnswer ? 'error' : 'elevation'}
        sx={{
          width: '40px',
          height: '40px',
          alignContent: 'center',
          display: { xs: 'none', sm: 'grid' },
          border: wrongAnswerBorder,
          boxShadow: underline
            ? `1px 1px 5px 0px ${theme.palette.underline.main}, 0px 1px 1px 0px ${theme.palette.underline.main}, 0px 2px 2px 0px ${theme.palette.underline.main}`
            : 'initial',
          backgroundColor: isUnrevealedLetter() ? 'secondary.main' : 'initial',
          marginTop: '8px',
        }}
      >
        <Typography textAlign="center" variant="h4">
          {letter === '' ? ' ' : letter}
        </Typography>
      </Paper>

      {/* Mobile version: */}
      <Paper
        elevation={6}
        className={`${isUnrevealedLetter() ? 'answer-letter-animation' : ''}`}
        sx={{
          width: '30px',
          height: '30px',
          alignContent: 'center',
          display: { xs: 'grid', sm: 'none' },
          border: wrongAnswerBorder,
          borderBottom: underlineBorderBottom,
          backgroundColor: isUnrevealedLetter() ? 'secondary.main' : 'initial',
          marginTop: '8px',
        }}
      >
        <Typography textAlign="center" variant="h6">
          {letter === '' ? ' ' : letter}
        </Typography>
      </Paper>
    </>
  );
};
